/**
 * Application-wide constants
 */

// Daily usage limits for free users
export const DAILY_LIMITS = {
  TRANSCRIPT: 3,
  SUMMARY: 2,
  WHISPER: 1,
  // Caption transcripts are unlimited for Pro, but Whisper (captionless audio)
  // carries real residential-proxy + speech-to-text cost, so Pro gets a generous
  // daily fair-use ceiling. Chosen to sit in the empty 11-30/day band where no
  // real subscriber lives while capping the outlier tail. Tunable.
  PRO_WHISPER: 25,
} as const;

// Account switching rate limit
export const MAX_ACCOUNTS_PER_IP = 2;
export const ACCOUNT_SWITCH_WINDOW_SECONDS = 2 * 60 * 60; // 2 hours
